// extracted by mini-css-extract-plugin
module.exports = {"hide":"Main_hide__1Vv78","Login_Btn":"Main_Login_Btn__1rEEr"};